export default __webpack_public_path__ + "75db11a53e3a5e08b44bbe440c71fa46.svg";